import { initAuth0 } from '@auth0/nextjs-auth0'
import type { GetSession } from '@auth0/nextjs-auth0'
import { getPartnerAuth0Config } from './auth0.config'
import { NextRequestParameter } from '../utils'

// Implemented to reduce amount of times the auth0 server was initialised
const partnerInstanceCache: Record<string, ReturnType<typeof initAuth0> | undefined> = {}

const createCacheKey = (authConfig: ReturnType<typeof getPartnerAuth0Config>) => {
  return `${authConfig.iataCode}:${authConfig.config.issuerBaseURL}:${authConfig.config.baseURL}`
}

export const getAuth0Server = (req: NextRequestParameter) => {
  const { config, iataCode } = getPartnerAuth0Config(req)
  const cacheKey = createCacheKey({ config, iataCode })
  const instance = partnerInstanceCache[cacheKey]
  if (instance) {
    return instance
  }
  partnerInstanceCache[cacheKey] = initAuth0(config)
  return partnerInstanceCache[cacheKey]
}

type RequestParameters = Exclude<Parameters<GetSession>, []>

export const getAccessToken = (...args: RequestParameters) => {
  const [req] = args
  return getAuth0Server(req).getAccessToken(...args)
}

export const getSession = (...args: RequestParameters): ReturnType<GetSession> => {
  const [req] = args
  return getAuth0Server(req).getSession(...args)
}
